import { Controller } from "@hotwired/stimulus";
// import { Howl } from "howler";

// Connects to data-controller="howlerjs"
export default class extends Controller {
  // 1. Defined Targets: Combined Styling targets + Audio targets
  static targets = [
    "align",
    "backgrnd",
    "mssgtime",
    "audio",
    "playIcon",
    "pauseIcon",
    "progress",
    "currentTime",
    "duration",
  ];

  // 2. Values
  static values = {
    user: String,
  };

  connect() {
    this.applyStyling();
  }

  applyStyling() {
    const messageUser = this.userValue;
    const alignmentEl = this.alignTarget;
    const backgroundEl = this.backgrndTarget;
    const messageTimeEl = this.mssgtimeTarget;

    // Check Global window.currentUser
    if (window.currentUser === messageUser) {
      // --- My Message (Right / Green) ---
      alignmentEl.classList.add("justify-end");

      backgroundEl.classList.add("bg-[#d9fdd3]");
      backgroundEl.classList.add("text-gray-900");
      backgroundEl.classList.add("rounded-tr-none"); // WhatsApp Style corner

      // Make slider white so it's visible on green bg
      if (this.hasProgressTarget)
        this.progressTarget.classList.add("accent-white");
    } else {
      // --- Their Message (Left / Gray) ---
      alignmentEl.classList.add("justify-start");

      backgroundEl.classList.add("bg-gray-100");
      backgroundEl.classList.add("text-gray-900");
      backgroundEl.classList.add("rounded-tl-none"); // WhatsApp Style corner

      messageTimeEl.classList.add("text-gray-500");

      // Make slider green so it stands out on gray bg
      if (this.hasProgressTarget)
        this.progressTarget.classList.add("accent-green-600");
    }
  }

  // --- AUDIO LOGIC BELOW ---

  toggle(e) {
    e.preventDefault();
    if (this.audioTarget.paused) {
      this.play();
    } else {
      this.pause();
    }
  }

  play() {
    // Stop all other audios on page
    document.querySelectorAll("audio").forEach((audio) => {
      if (audio !== this.audioTarget) audio.pause();
    });

    this.audioTarget.play();
    this.playIconTarget.classList.add("hidden");
    this.pauseIconTarget.classList.remove("hidden");
  }

  pause() {
    this.audioTarget.pause();
    this.playIconTarget.classList.remove("hidden");
    this.pauseIconTarget.classList.add("hidden");
  }

  reset() {
    this.pause();
    this.audioTarget.currentTime = 0;
    this.progressTarget.value = 0;
    this.currentTimeTarget.textContent = "0:00";
  }

  updateProgress() {
    const current = this.audioTarget.currentTime;
    const duration = this.audioTarget.duration;

    if (duration > 0) {
      const percent = (current / duration) * 100;
      this.progressTarget.value = percent;
      this.currentTimeTarget.textContent = this.formatTime(current);
    }
  }

  scrub() {
    const duration = this.audioTarget.duration;
    if (duration) {
      const scrubTime = (this.progressTarget.value / 100) * duration;
      this.audioTarget.currentTime = scrubTime;
    }
  }

  setDuration() {
    const duration = this.audioTarget.duration;
    if (!isNaN(duration)) {
      this.durationTarget.textContent = this.formatTime(duration);
    }
  }

  formatTime(seconds) {
    if (!seconds || isNaN(seconds)) return "0:00";
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  }
}
